import React, { PropsWithChildren } from "react";
import { useKeycloak } from "./keycloak-provider";

export interface AuthenticationVerifierProps {
  propertyTicker?: string;
}

export function AuthenticationVerifier(props: PropsWithChildren<AuthenticationVerifierProps>) {
  const keycloak = useKeycloak();

  if (keycloak.authenticated) {
    return <>{props.children}</>;
  }

  keycloak.login();
}